export const formatCount = (count) => {
    if(count === 0){
        return 0;
    }
    if (count < 1000) {
        return count.toString(); // return original value for counts less than 1000
    } else if (count < 100000) {
        const countString = (count / 1000).toFixed(1); // convert to K format with one decimal place
        return `${countString}K`;
    } else if (count < 1000000000) {
        const countString = (count / 1000000).toFixed(1); // convert to M format with one decimal place
        return `${countString}M`;
    } else {
        const countString = (count / 1000000000).toFixed(1); // convert to B format with one decimal place
        return `${countString}B`;
    }
};

export const CountPositiveComments = (comments) => {
    let count = 0;

    comments?.forEach(element => {
    
        if (!element?.flag) {
            count++;
        }
    });


    return formatCount(count);
}